import {
  initPlansSwitcher,
  initPlansSlider,
} from "./components/pricing-plans/index.js";

export class PricingPage {
  constructor(options) {
    this.options = $.extend(
      {
        node: $(".pricing-plans"),
      },
      options
    );

    $(window).on("resize", () => {
      this._initIncludedFeaturesAccordion();
    });

    initPlansSwitcher();
    initPlansSlider();
    this._initIncludedFeaturesAccordion();
    // this._initEnterprisePopup();
  }

  _initIncludedFeaturesAccordion() {
    var width = $(window).width();

    if (width < 768) {
      // add accordion

      $(".plans-include__item .item__content").css("max-height", "0");

      $(".plans-include__item .item__header").on("click", (event) => {
        let $target = $(event.currentTarget);
        let $content = $target.next();

        $target.toggleClass("active");

        if ($content.height() != 0) {
          $content.css("max-height", 0);
          $content.removeClass("expanded");
        } else {
          $content.css("max-height", $content[0].scrollHeight + "px");
          $content.addClass("expanded");
        }

        $(".plans-include__item .item__content")
          .not($content)
          .css("max-height", 0);
        $(".plans-include__item .item__header")
          .not($target)
          .removeClass("active");
        $(".plans-include__item .item__content")
          .not($content)
          .removeClass("expanded");
      });
    } else {
      // remove accordion

      $(".plans-include__item .item__content").css("max-height", "none");
      $(".plans-include__item .item__header").removeClass("active");

      $(".plans-include__item .item__header").off("click");
    }
  }

}

new PricingPage();

